import * as d3 from 'd3';
import { addToStack, getPositionInScene } from "../Util";
import { createNewItem, select } from "../canvasSlice";
import store from "../store";

let clickHeld = false, downX, downY, moved = false;

export const mouseDown = (e, scene) => {
    clickHeld = true;
    const p = getPositionInScene(e.clientX, e.clientY);
    downX = p[0];
    downY = p[1];
}

export const mouseUp = (e, scene, datasets, renderer, undoStack) => {
    clickHeld = false;
    let rect = d3.select("#rectToolUI");
    rect.style("visibility", "hidden");
    if (moved) {
        addToStack(scene, datasets, undoStack);
        let r = scene.mark("rect", {left: parseInt(rect.attr("x")), top: parseInt(rect.attr("y")), 
                width: parseInt(rect.attr("width")), height: parseInt(rect.attr("height"))});
        store.dispatch(createNewItem(r.id));
        store.dispatch(select([r.id]));
        renderer.render(scene);
    }
    moved = false;
}

export const mouseMove = (e, scene) => {
    if (!clickHeld) return;
    moved = true;
    let p = getPositionInScene(e.clientX, e.clientY);
    let x1 = downX, x2 = p[0], y1 = downY, y2 = p[1];
    let x, y, width, height;
    x = Math.min(x1, x2);
    y = Math.min(y1, y2);
    width = Math.abs(x1 - x2);
    height = Math.abs(y1 - y2);
    if (e.shiftKey) {
        width = Math.min(width, height);
        height = width;
        x = x1 < x2 ? x1 : x1 - width;
        y = y1 < y2 ? y1 : y1 - height;
    }
    d3.select("#rectToolUI").style("visibility", "visible").attr("x", x).attr("y", y)
        .attr("width", width).attr("height", height);
}